/* eslint-disable @typescript-eslint/no-unused-vars */
/* global Swiper */
declare const Swiper: any;
//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;
import jQuery from "jquery";

const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

$(document).ready(function () {
  // .gr-header-btnがクリックされたときの処理
  $(".gr-header-btn").click(function () {
    // .gr-header-btnと.gr-header-spのopenクラスをトグル（追加/削除）
    $(".gr-header-btn, .gr-header-sp").toggleClass("open");
  });

  // .gr-header-sp内のaタグがクリックされたときの処理
  $(".gr-header-sp a").click(function () {
    // .gr-header-btnと.gr-header-spからopenクラスを削除
    $(".gr-header-btn, .gr-header-sp").removeClass("open");
  });

  // FAQ アコーディオン機能
  $(".faq-content-box--q").click(function () {
    const $parentBox = $(this).closest(".faq-content-box");
    const $hideContent = $parentBox.find(".faq-content-box--hide");

    $hideContent.stop().slideToggle();
    $parentBox.toggleClass("active");
  });

  //展開の処理
  $(".work-cat--title").on("click", function () {
    if ($(window).width() <= 768) {
      const $this = $(this);
      const $inner = $this.next(".work-cat--inner");

      // アニメーションがパカパカしないようにstopを入れる
      $inner.stop(true, true).slideToggle(300);

      // activeクラスの切り替え
      $this.toggleClass("active");
    }
  });

  // スマホ用ヘッダーアコーディオン機能
  $(".gr-header-sp-box--title").on("click", function () {
    if ($(window).width() <= 768) {
      const $this = $(this);
      const $inner = $this.siblings(".gr-header-sp-box--inner");

      // アニメーションがパカパカしないようにstopを入れる
      $inner.stop(true, true).slideToggle(300);

      // activeクラスの切り替え
      $this.toggleClass("active");
    }
  });

  // 絞り込み機能
  $(".work-cat--btn .btn-dull").on("click", function (e) {
    e.preventDefault();

    // チェックされたチェックボックスからタクソノミーと値を取得
    const checkedValues = [];
    $(".work-cat-box input[type='checkbox']:checked").each(function () {
      checkedValues.push($(this).val());
    });

    // 全てのwork-archive-boxを取得
    const $workBoxes = $(".work-archive-box");

    // まず全てをフェードアウト
    $workBoxes.fadeOut(300, function () {
      // フェードアウトが完了してから表示対象を決定
      if (checkedValues.length === 0) {
        // チェックがない場合は全て表示
        $workBoxes.fadeIn(300);
      } else {
        // チェックがある場合はフィルタリングして表示対象を決定
        const $boxesToShow = [];

        $workBoxes.each(function () {
          const $box = $(this);
          const dataCat = $box.attr("data-cat");
          let shouldShow = false;

          if (dataCat) {
            // data-cat属性の値をスペースで分割してタームの配列を作成
            const categoryTerms = dataCat.split(" ");

            // チェックされた値がすべてdata-catに含まれているかチェック（AND検索）
            shouldShow = checkedValues.every((value) => categoryTerms.includes(value));
          }

          if (shouldShow) {
            $boxesToShow.push($box);
          }
        });

        // 表示対象のみフェードイン
        $boxesToShow.forEach(function ($box) {
          $box.fadeIn(300);
        });
      }
    });
  });
});

// 別ページからのアンカーリンク遷移対応
// 画像読み込みによるレイアウトシフト後に正しい位置へ再スクロール
window.addEventListener("load", function () {
  if (location.hash) {
    const target = document.querySelector(location.hash);
    if (target) {
      const header = document.querySelector(".gr-header") as HTMLElement | null;
      const headerHeight = header ? header.offsetHeight : 0;
      const offsetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }
  }
});

//TOP メインの下のスライド
new Swiper(".front_top_Swiper", {
  slidesPerView: 1, // スマホ時：1枚ずつ表示
  spaceBetween: 15,
  loop: true, // 無限ループON
  speed: 700,
  rewind: false, // 往復しない
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
    reverseDirection: false, // 左方向（次へ進む）を明示
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 3, // PC時：3枚表示
      spaceBetween: 28,
    },
  },
});

//TOP モデルハウスのスライド
new Swiper(".swiper-container", {
  slidesPerView: 1.2,
  spaceBetween: 15,
  centeredSlides: false,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 2.3,
      spaceBetween: 30,
    },
  },
});

//TOP イベントのスライド
new Swiper(".front_event_Swiper", {
  slidesPerView: 1.1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 22, // スマホ向けに余白も調整（任意）
    },
  },
});

new Swiper(".modelhouse-swiper", {
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

new Swiper(".land-swiper", {
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

new Swiper(".landEnvironment-swiper", {
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

//Staffの表示の切り替え
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".staff-top--cat em");
  const boxes = document.querySelectorAll(".staff-content-box");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // active切り替え
      tabs.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      const category = this.classList.contains("all") ? "all" : this.classList[0];

      boxes.forEach((box) => {
        // 表示中のものだけfade-out（アニメで消す）
        if (box.classList.contains("fade-in")) {
          box.classList.remove("fade-in");
          setTimeout(() => {
            box.classList.add("hidden");
          }, 500); // アニメ終了後にdisplay:none
        } else {
          box.classList.add("hidden");
        }
      });

      // 遅延して表示対象をfade-in
      setTimeout(() => {
        boxes.forEach((box) => {
          if (category === "all" || box.classList.contains(category)) {
            box.classList.remove("hidden");
            // 再描画してからアニメ適用
            requestAnimationFrame(() => {
              box.classList.add("fade-in");
            });
          }
        });
      }, 500); // チラつき防止：非表示が終わってから表示
    });
  });
});

const caseSwiperTop = new Swiper(".front-case-slide--top .case-swiper", {
  slidesPerView: 1.7,
  spaceBetween: 8,
  loop: true,
  loopAdditionalSlides: 3,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 6000,
  allowTouchMove: false,
  simulateTouch: false,
  grabCursor: false,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
  },
});

const caseSwiperBottom = new Swiper(".front-case-slide--bottom .case-swiper", {
  slidesPerView: 1.7,
  spaceBetween: 8,
  loop: true,
  centeredSlides: true,
  freeMode: false,
  autoplay: {
    delay: 0,
    reverseDirection: true,
  },
  speed: 6000,
  allowTouchMove: false,
  simulateTouch: false,
  grabCursor: false,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
  },
});

new Swiper(".front-lineup-swiper", {
  slidesPerView: 1.3,
  spaceBetween: 15,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
  },
});

new Swiper(".idea-swiper", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.7,
      spaceBetween: 30,
    },
  },
});

//EXe メインビジュアルのサムネイル付きスライド
const exePhotoThumbs = new Swiper(".exe-photo-thumbs", {
  slidesPerView: 4,
  spaceBetween: 5,
  watchSlidesProgress: true,
  breakpoints: {
    768: {
      slidesPerView: 7,
      spaceBetween: 15,
    },
  },
});

const exePhotoSwiper = new Swiper(".exe-swiper-container", {
  spaceBetween: 15,
  thumbs: {
    swiper: exePhotoThumbs,
  },
  autoplay: {
    delay: 3000,
  },
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
});

new Swiper(".hiraya-swiper", {
  slidesPerView: 1, // ← 常に1枚表示
  spaceBetween: 0, // ← 画像の間に隙間を作らない
  centeredSlides: false, // ← 左寄せ（デフォルト）でOK
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1, // ← PCでも1枚
      spaceBetween: 0,
    },
  },
});

new Swiper(".machi-ie-swiper", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.7,
      spaceBetween: 30,
    },
  },
});

new Swiper(".land-floor-swiper", {
  slidesPerView: 1, // ← 常に1枚表示
  spaceBetween: 0, // ← 画像の間に隙間を作らない
  centeredSlides: false, // ← 左寄せ（デフォルト）でOK
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1, // ← PCでも1枚
      spaceBetween: 0,
    },
  },
});

new Swiper(".crea2026-swiper", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.8,
      spaceBetween: 30,
    },
  },
});

// ZEB ページのスライダー
new Swiper(".zeb-swiper", {
  slidesPerView: 1.5,
  spaceBetween: 15,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
  },
});

// スクロール連動のふわっと表示アニメーション
const initFadeup = () => {
  const fadeElements = document.querySelectorAll(".js-fadeup");
  if (fadeElements.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-active");
            observer.unobserve(entry.target); // 一度だけ発火
          }
        });
      },
      {
        rootMargin: "0px 0px -15% 0px", // 画面下部15%に入ったら発火
        threshold: 0,
      },
    );

    fadeElements.forEach((el) => {
      observer.observe(el);
    });
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFadeup);
} else {
  initFadeup();
}
